import { render, staticRenderFns } from "./TokenHolder.vue?vue&type=template&id=6fa15d18&"
import script from "./TokenHolder.vue?vue&type=script&lang=js&"
export * from "./TokenHolder.vue?vue&type=script&lang=js&"
import style0 from "./TokenHolder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports